import { AerodromoService } from 'src/app/services/geral/aerodromo.service';
import { Aerodromo } from 'src/app/model/geral/aerodromo';
import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../../generic/formgenerico/formgenerico';

@Component({
  selector: 'app-form-aerodromo',
  templateUrl: '../../generic/formgenerico/formgenerico.component.html',
  styleUrls: [ '../../generic/formgenerico/formgenerico.component.css']
})

export class FormAerodromoComponent extends FormGenerico<Aerodromo> implements OnInit {

  constructor(
    injectorObj: Injector,
    api: AerodromoService)
  {
    super(injectorObj, api);
    this.obj = new Aerodromo();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraObj(res: any) {
  }

  protected onPropertyChange(propName: string, newValue: any): void {}
}
